<template>
    <button
        ref="burger"
        :class="{ 'burger-button--open': isOpen }"
        class="burger-button"
        v-on="$listeners"
    >
        <svg :aria-expanded="isOpen"
             :style="{ fill: color }"
             class="burger-button__glyph"
             xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 15.91 12.19"
        >
            <path class="burger-button__line burger-button__line--1"
                  d="M2.29 10.26L12.13.43a1 1 0 0 1 1.41 0l.06.06a1 1 0 0 1 0 1.41l-9.83 9.84a1 1 0 0 1-1.41 0l-.06-.06a1 1 0 0 1-.01-1.42z"
            />
            <path class="burger-button__line burger-button__line--2"
                  d="M1 5h13.91a1 1 0 0 1 1 1v.09a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1z"
            />
            <path class="burger-button__line burger-button__line--3"
                  d="M3.78.44l9.84 9.84a1 1 0 0 1 0 1.41l-.06.06a1 1 0 0 1-1.41 0L2.3 1.91A1 1 0 0 1 2.3.5l.06-.06a1 1 0 0 1 1.42 0z"
            />
        </svg>
        <span class="burger-button__label">Menu</span>
    </button>
</template>

<script>
    export default {
        name: 'BurgerButton',

        props: {
            isOpen: { type: Boolean, default: false },
            color:  { type: String, default: '#000000' },
        },
    };
</script>

<style scoped lang="scss">
    @import '~@/assets/styles/abstracts/_variables';
    @import '~@/assets/styles/abstracts/_mixins';

    .burger-button {
        &__label {
            @include sr-only;
        }

        &__glyph {
            position: relative;

            width:    1em;
            height:   1em;
        }

        &__line {
            transform-origin: center center;

            transition:       all 150ms ease-in-out;

            &--1 {
                transform: translateY(0.5rem) rotate(45deg);
            }

            &--2 {
                opacity:             1;
                transition-duration: 100ms;
            }

            &--3 {
                transform: translateY(-0.5rem) rotate(-45deg);
            }
        }

        &--open &__line {
            transform: none;
        }

        &--open &__line--2 {
            opacity: 0;
            transform: translate(-100%);
        }
    }
</style>
